var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33.586 33.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sort",
    transform: "translate(-0.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1931",
    "data-name": "Group 1931",
    transform: "translate(0.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1930",
    "data-name": "Group 1930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M8.38,0h-2L1.5,13.964H4.274l.734-2.1H9.7l.724,2.1H13.2ZM5.927,9.244,7.371,5.117,8.795,9.244Z",
    transform: "translate(-1.496)",
    fill: "#d0d0d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1933",
    "data-name": "Group 1933",
    transform: "translate(17.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1932",
    "data-name": "Group 1932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M278,23.649l-4.983,4.983V0h-2.622V28.632l-4.983-4.983L263.555,25.5l8.148,8.148,8.148-8.148Z",
    transform: "translate(-263.555)",
    fill: "#d0d0d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1935",
    "data-name": "Group 1935",
    transform: "translate(0.499 19.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1934",
    "data-name": "Group 1934",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M12.431,299.247H.5v2.622H8.487L.5,311.151v2.06H12.3v-2.622H4.443l7.988-9.282Z",
    transform: "translate(-0.499 -299.247)",
    fill: "#d0d0d0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsc);
export default __webpack_public_path__ + "static/media/asc.f93e55f73d2c35481f8d275ff21ebdda.svg";
export { ForwardRef as ReactComponent };